export default "__VITE_ASSET__Dsk$u$JP__"